<h3 class="bold overflow-ellipsis break-word" *ngIf="!useInternalDesign">
  <ng-container [ngTemplateOutlet]="headerContentTemplate"></ng-container>
</h3>
<h5 class="overflow-ellipsis break-word" *ngIf="useInternalDesign">
  <ng-container [ngTemplateOutlet]="headerContentTemplate"></ng-container>
</h5>
<ng-template #headerContentTemplate>
  <ng-container *ngIf="title?.length">{{ title | translate }}</ng-container>
  <ng-container *ngIf="titleTemplate" [ngTemplateOutlet]="titleTemplate"></ng-container>
  <mat-icon class="svg-icon text-muted left-spacer-half" *ngIf="tooltip?.length" [svgIcon]="'info'" [matTooltip]="tooltip | translate"></mat-icon>
  <span class="text-warning normal" *ngIf="required"> *</span>
</ng-template>
